// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";

import {
    ContentBlock,
    OneLinkProps,
    OneButtonProps
} from "../../../../components/wpl/content-block/src";
import {
    BGStyles,
    BGProps,
    Row
} from "../../../../libraries/wpl/foundations/src";

export interface PatternCTAMobileProps {
    headerText: string;
    bodyText?: string;
    eyebrowText?: string;
    footNoteText?: string;
    ctaProps?: OneLinkProps | OneButtonProps;
    className?: string;
    backgroundProperties?: BGProps;
}

const ctaPrimaryStyle = css`
    padding: 64px 0;
    text-align: center;

    ${UNSAFE_media.only.sm} {
        padding: 48px 0;
    }

    ${UNSAFE_media.below.sm} {
        padding: 32px 0;
    }

    .footnote-text {
        font-size: 0.875rem;
        margin: 30px auto 0;
    }
`;

export const CTAPrimary = ({
    headerText,
    bodyText,
    className,
    eyebrowText,
    footNoteText,
    ctaProps,
    backgroundProperties
}: PatternCTAMobileProps) => {
    return (
        <div
            className={className}
            css={[BGStyles(backgroundProperties), ctaPrimaryStyle]}
        >
            <Row layout="reduced" alignItems="center">
                <div className="primary-cta-content">
                    <ContentBlock
                        isCentered={true}
                        headerText={headerText}
                        headerType="h2"
                        eyebrowText={eyebrowText}
                        bodyText={bodyText}
                        ctaProps={ctaProps}
                    />

                    {footNoteText ? (
                        <p className="footnote-text">{footNoteText}</p>
                    ) : null}
                </div>
            </Row>
        </div>
    );
};
